import EquipmentFormatter from './EquipmentFormatter'

export { withEquipment, equipmentDataPropName } from './EquipmentFormatter'

export default EquipmentFormatter
